import { BaseService } from "services/_baseService";

class FlightsAdminService extends BaseService<any> {
  constructor() {
    super(`flights`);
  }
}

export default new FlightsAdminService();
